import { Box, Button, Card, CardContent, Skeleton, Typography, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import React from 'react';

// ----------------------------------------------------------------------

export const RootStyle = styled(Card)(({ theme }) => ({
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
        // height: '100%',
        display: 'flex',
        textAlign: 'left',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
}));

// ----------------------------------------------------------------------

const ModuleCardSkeleton: React.FunctionComponent = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <RootStyle>
            <CardContent
                sx={{
                    p: { md: 3 },
                    pl: { md: 5 },
                    color: 'grey.800',
                    width: '100%',
                }}
            >
                {isMobile && (
                    <Box
                        sx={{
                            p: { md: 3 },
                            pb: { xs: 3 },
                            margin: { xs: 'auto', md: 'inherit' },
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <Skeleton width={96} height={96} variant='rectangular' />
                    </Box>
                )}

                <Typography gutterBottom variant='h5'>
                    <Skeleton sx={{ width: '80%', mx: { xs: 'auto', md: 'inherit' } }} />
                </Typography>

                <Typography
                    variant='body2'
                    sx={{ pb: { xs: 3, xl: 5 }, maxWidth: 480, mx: { xs: 'auto', md: 'inherit' } }}
                >
                    <Skeleton sx={{ width: '50%', mx: { xs: 'auto', md: 'inherit' } }} />
                </Typography>

                <Skeleton sx={{ mx: { xs: 'auto', md: 'inherit' } }}>
                    <Button variant='contained'>Continue</Button>
                </Skeleton>
            </CardContent>

            {!isMobile && (
                <Box
                    sx={{
                        p: { md: 3 },
                        margin: 'inherit',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Skeleton sx={{ transform: 'none' }} height={124} width={128} />
                </Box>
            )}
        </RootStyle>
    );
};

export default ModuleCardSkeleton;
